@if (site$ | async; as site) {
    <div class="flex flex-col gap-medpace-field pb-4">
        <label>Shipping Address is the same as Primary Site Address? </label>
        <mds-radio-group
            [buttons]="adressRadioButtons"
            [formCtrl]="addressSameAsPrimaryControl"
            id="sameAdress"
            (changeEvent)="selectValue($event)"
        >
        </mds-radio-group>
    </div>
    @if (isEditing && !this.sameAsPrimaryAddress) {
        <div class="flex flex-col gap-medpace-field">
            <mds-text-field
                id="shipping_line1"
                [formCtrl]="addressFormGroup.controls.sline1Control"
                placeholder="Type here..."
                appearance="outline"
                inputType="text"
                label="Address Line 1"
                width="100%"
                [required]="true"
                (input)="emitStringChange($event, { id: 'shipping_line1' })"
                appGoogleMapsAutocomplete
                (placeChangeEvent)="googleMapsAutocompletePlaceChange($event)"
            ></mds-text-field>

            <mds-text-field
                id="shipping_line2"
                [formCtrl]="addressFormGroup.controls.sline2Control"
                placeholder="Type here..."
                appearance="outline"
                inputType="text"
                label="Address Line 2"
                width="100%"
                (input)="emitStringChange($event, { id: 'shipping_line2' })"
            ></mds-text-field>

            <mds-text-field
                id="shipping_city"
                [formCtrl]="addressFormGroup.controls.scityControl"
                placeholder="Type here..."
                appearance="outline"
                inputType="text"
                label="City"
                width="100%"
                [required]="true"
                (input)="emitStringChange($event, { id: 'shipping_city' })"
            ></mds-text-field>

            <div class="grid grid-cols-2 gap-medpace-field">
                <mds-text-field
                    id="shipping_stateOrProvince"
                    [formCtrl]="addressFormGroup.controls.sstateOrProvinceControl"
                    placeholder="Type here..."
                    appearance="outline"
                    inputType="text"
                    [label]="regionStateType$ | async"
                    width="100%"
                    (input)="emitStringChange($event, { id: 'shipping_stateOrProvince' })"
                ></mds-text-field>

                <mds-text-field
                    id="shipping_postalCode"
                    [formCtrl]="addressFormGroup.controls.spostalCodeControl"
                    placeholder="Type here..."
                    appearance="outline"
                    inputType="text"
                    label="Zipcode/Postal Code"
                    width="100%"
                    [required]="true"
                    (input)="emitStringChange($event, { id: 'shipping_postalCode' })"
                ></mds-text-field>
            </div>

            <mds-dropdown
                [closeOnPageScroll]="false"
                [formCtrl]="addressFormGroup.controls.sregionControl"
                appearance="outline"
                label="Region"
                placeholder="Please select region"
                [options]="regions$ | async"
                id="shipping_regionDropdown"
                [required]="true"
                (selectionChange)="emitChange($event.value, { id: 'shipping_region' })"
            ></mds-dropdown>

            <mds-autocomplete
                [closeOnPageScroll]="false"
                [options]="countries$ | async"
                appearance="outline"
                placeholder="Please enter country"
                label="Country"
                id="shipping_countryAutocomplete"
                inputType="text"
                [formCtrl]="addressFormGroup.controls.scountryControl"
                [required]="true"
            >
            </mds-autocomplete>
        </div>
    }
    @if (!this.sameAsPrimaryAddress && !isEditing && !loaderSpinner && site$ | async; as site) {
        <div class="flex flex-col gap-medpace">
            <div>
                <h5>Address Line 1</h5>
                <span>{{ site?.shippingAddress?.line1 }}</span>
            </div>

            @if (site?.shippingAddress?.line2) {
                <div>
                    <h5>Address Line 2</h5>
                    <span>{{ site?.shippingAddress?.line2 }}</span>
                </div>
            }

            <div class="grid grid-cols-3 gap-medpace">
                <div>
                    <h5>City</h5>
                    <span>{{ site?.shippingAddress?.city }}</span>
                </div>
                <div>
                    <h5>{{ regionStateType$ | async }}</h5>
                    <span>{{ site?.shippingAddress?.stateOrProvince }}</span>
                </div>
                <div>
                    <h5>Zipcode/Postal Code</h5>
                    <span>{{
                        site?.shippingAddress?.postalCode ? site?.shippingAddress?.postalCode : 'Unspecified'
                    }}</span>
                </div>
            </div>
            <div class="grid grid-cols-3 gap-medpac">
                <div>
                    <h5>Region</h5>
                    <span>{{ site?.shippingAddress?.region }}</span>
                </div>
                <div>
                    <h5>Country</h5>
                    <span>{{ site?.shippingAddress?.country }}</span>
                </div>
            </div>
        </div>
    }
}

@if (!isEditing && loaderSpinner) {
    <medpace-loading-card></medpace-loading-card>
}
